import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
// Core components
import Tooltip from 'components/core/Tooltip';
// Models
import mBooking from 'models/cpm/booking';
// Custom
import { cpmBookingDataShape } from 'constants/PropTypesShapes';
import AppIcon from 'components/icons/AppIcon';

const MyBookingStatusInfoIcon = ({ booking }) => {
  // Get parking status
  const { icon, color, value } = mBooking.bookingStatus(booking);

  // Build icon
  const infoIcon = <AppIcon id={icon} color={color} />;

  return (
    <div className="d-flex">
      <Tooltip
        content={
          <LocalizedMessage id="info.bookingStatusDesc" values={{ status: value }} />
        }
      >
        {infoIcon}
      </Tooltip>
    </div>
  );
};

MyBookingStatusInfoIcon.propTypes = {
  booking: cpmBookingDataShape.isRequired,
};

module.exports = MyBookingStatusInfoIcon;



// WEBPACK FOOTER //
// ./routes/my_bookings/assets/MyBookingStatusInfoIcon.js